import { render, staticRenderFns } from "./AddEchipa.vue?vue&type=template&id=fd083510&scoped=true"
import script from "./AddEchipa.vue?vue&type=script&lang=js"
export * from "./AddEchipa.vue?vue&type=script&lang=js"
import style0 from "./AddEchipa.vue?vue&type=style&index=0&id=fd083510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd083510",
  null
  
)

export default component.exports